import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useAdminAuctionStore } from '@features/admin/auctions/useAdminAuctionStore.ts';
import AuctionsPage from '@features/admin/auctions/AuctionsPage.tsx';

const adminAuctionsSearchSchema = z.object({
  code: z.string().optional(),
  name: z.string().optional(),
  portalId: z.coerce.number().optional(),
  validTo: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(10),
});

export type AdminAuctionsSearch = z.infer<typeof adminAuctionsSearchSchema>;

export const Route = createFileRoute('/admin/auctions/')({
  validateSearch: search => adminAuctionsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { code, name, portalId, validTo, page, size } = ctx.search;
    useAdminAuctionStore.getState().loadAuctions({
      code,
      name,
      portalId,
      validTo,
      page: page || 1,
      size: size || 10,
    });
  },
});

function RouteComponent() {
  return <AuctionsPage />;
}
